module.exports = __webpack_public_path__ + "img/alemania.4d2df237.jpg";